import React from 'react'
import { VulnerabilityPolicy, VulnerabilityPolicyAction } from '.'
import {
  GenericSorter,
  SortOrder,
  GenericFilterer
} from '../../legacy-design-system/legacy-grid'
import { VulnerabilityPoliciesGridManagerView } from './vulnerability-policies-grid-manager-view'
import { Role } from '@contrast-security-inc/base-types'

interface Props {
  readonly organizationID: string
  readonly organizationRole: Role
  readonly loading: boolean
  readonly refetch: () => Promise<any>
  readonly vulnerabilityPolicies: VulnerabilityPolicy[]
  readonly action: VulnerabilityPolicyAction
}

const filterByName = (item: VulnerabilityPolicy, value: string) =>
  item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1

export function VulnerabilityPoliciesGridManager({
  organizationID,
  organizationRole,
  loading,
  refetch,
  vulnerabilityPolicies,
  action
}: Props) {
  const noData = loading === false && vulnerabilityPolicies.length === 0

  return (
    <GenericFilterer<VulnerabilityPolicy>
      data={vulnerabilityPolicies}
      filterFns={[filterByName]}
    >
      {({ filtered, onSearch }) => {
        return (
          <GenericSorter<VulnerabilityPolicy>
            data={filtered}
            defaultSortConfig={{
              field: 'name',
              order: SortOrder.DESC,
              getValue: ({ name }) => name
            }}
          >
            {({ sorted, onSort, activeSortConfig }) => {
              return (
                <VulnerabilityPoliciesGridManagerView
                  noData={noData}
                  loading={loading}
                  refetch={refetch}
                  organizationID={organizationID}
                  organizationRole={organizationRole}
                  vulnerabilityPolicies={sorted}
                  action={action}
                  onSort={onSort}
                  onSearch={onSearch}
                  activeSortConfigs={
                    !!activeSortConfig ? [activeSortConfig] : []
                  }
                />
              )
            }}
          </GenericSorter>
        )
      }}
    </GenericFilterer>
  )
}
